import { Icon } from "@blueprintjs/core";
import Select from "react-select";

import { CreditPriceOption } from "@/components/pages_logged_in/services/CreditPriceOption";
import {
  BRAND_PURPLE,
  HOVER_BACKGROUND,
  INNER_BORDER_COLOR,
  LIGHTEST_BACKGROUND,
  MAINTEXT_COLOR,
} from "@/css/constants";
import { CreditPriceOption as ICreditPriceOption } from "@/types/products";

function CreditPriceSelectSingleValue({ data }: { data: ICreditPriceOption }) {
  return (
    <CreditPriceOption
      price={data.value}
      noBorder
      css={{ height: "auto", padding: 0 }}
    />
  );
}

interface CreditPriceSelectOptionProps {
  data: ICreditPriceOption;
  selectOption: (option: ICreditPriceOption) => void;
  isSelected: boolean;
}

function CreditPriceSelectOption({
  data,
  selectOption,
  isSelected,
}: CreditPriceSelectOptionProps) {
  return (
    <CreditPriceOption
      price={data.value}
      isLocked={data.isLocked}
      noBorder
      css={{
        height: 51,
        background: isSelected ? HOVER_BACKGROUND : LIGHTEST_BACKGROUND,
        "&:hover": {
          background: data.isLocked ? LIGHTEST_BACKGROUND : HOVER_BACKGROUND,
        },
      }}
      onClick={() => {
        !data.isLocked && selectOption(data);
      }}
    />
  );
}

function DropdownIndicator() {
  return (
    <Icon icon="caret-down" color="#C4C4C4" style={{ paddingRight: 17 }} />
  );
}

interface CreditPriceSelectProps {
  options: ICreditPriceOption[];
  value?: ICreditPriceOption;
  onChange: (newValue: ICreditPriceOption) => void;
}

export function CreditPriceSelect({
  value,
  onChange,
  options,
}: CreditPriceSelectProps) {
  return (
    <Select<ICreditPriceOption>
      options={options}
      isSearchable={false}
      isMulti={false}
      placeholder="More Options"
      value={value}
      onChange={(newValue) => onChange(newValue as ICreditPriceOption)}
      styles={{
        container: (provided) => ({
          ...provided,
          zIndex: 99,
        }),
        placeholder: (provided) => ({
          ...provided,
          fontFamily: "inherit",
          fontWeight: 600,
          color: MAINTEXT_COLOR,
          paddingLeft: 20,
        }),
        control: (provided, state) => {
          const { menuIsOpen, isFocused, hasValue } = state;
          const borderColor =
            menuIsOpen || isFocused || hasValue
              ? BRAND_PURPLE
              : INNER_BORDER_COLOR;
          return {
            ...provided,
            border: `3px solid ${borderColor}`,
            borderRadius: 8,
            height: 60,
            "&:hover": {
              borderColor: BRAND_PURPLE,
            },
          };
        },
        valueContainer: (provided) => ({
          ...provided,
          overflow: "visible",
          display: "flex",
          alignItems: "center",
          padding: 0,
          margin: -2,
        }),
      }}
      components={{
        Option: CreditPriceSelectOption,
        IndicatorSeparator: null,
        SingleValue: CreditPriceSelectSingleValue,
        DropdownIndicator: DropdownIndicator,
      }}
    ></Select>
  );
}
